/**
 * @generated SignedSource<<a6a51a2330eb43d59c3e4ce98aa04cbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRewardEditor_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RewardEditor_TreeNodeFragment">;
  readonly " $fragmentType": "ProjectRewardEditor_TreeNodeFragment";
};
export type ProjectRewardEditor_TreeNodeFragment$key = {
  readonly " $data"?: ProjectRewardEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRewardEditor_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectRewardEditor_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RewardEditor_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "2088aa6eeee4880c980556f9c43187db";

export default node;
